import mixpanel from 'mixpanel-browser';

export const UboOnboardingAnalyticsService = {
  trackUboOnboardingStart: () => {
    mixpanel.track('Act on UBO Invitation', {
      Action: 'Get Started',
    });
  },
  trackUboPhoneSubmit: () => {
    mixpanel.track('UBO token enter', {
      Action: 'Continue',
    });
  },
  ssnValidate: () => {
    mixpanel.track('Act on UBO enter SSN', {
      Action: 'Continue',
    });
  },
  setPassword: () => {
    mixpanel.track('Act on UBO set password ', {
      Action: 'Set Password',
    });
  },
  completeUbo: () => {
    mixpanel.track('Act on UBO complete UBO', {
      Action: 'Complete UBO',
    });
  },
};
